import Daun1 from "../../../assets/images/s10_daun1.png"
import Daun2 from "../../../assets/images/s10_daun2.png"
import Bg from "../../../assets/images/s10_bg.png"
import Icon1 from '../../../assets/icons/s10_ic_1.png'
import Icon2 from '../../../assets/icons/s10_ic_2.png'
import Icon3 from '../../../assets/icons/s10_ic_3.png'
import { Link } from "react-router-dom"

const Section10 = () => {
    return (
        <div id="contact" className="w-full h-screen pt-20 flex flex-col items-center justify-center  relative">
            <h1 className="text-3xl md:text-5xl font-bold text-custom-green absolute top-20 z-10">Informasi Kontak</h1>
            <img src={Daun1} alt="Kebun Jitu" className='w-[200px] object-contain absolute left-0 z-10' loading='lazy' />
            <img src={Daun2} alt="Kebun Jitu" className='w-[200px] object-contain absolute right-0 z-10' loading='lazy' />
            <div className="w-full max-w-[60%] border-4 border-custom-orange bg-black text-white rounded-2xl overflow-hidden z-10 mb-10 md:mb-0">
                <div className="w-full grid grid-cols-1 md:grid-cols-3 bg-gradient-to-r from-custom-green to-custom-green/30 px-5 py-10 gap-3 ">
                    <Link
                        to="https://instagram.com/kebunjitu"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center justify-center cursor-pointer">
                        <img src={Icon1} alt="Kebun Jitu" className="w-12 aspect-square object-contain mb-5" loading='lazy' />
                        <h2 className="text-xl font-bold">Sosial Media</h2>
                        <p>@kebunjitu</p>
                    </Link>
                    <Link
                        to="/"
                        className="flex flex-col items-center justify-center cursor-pointer">
                        <img src={Icon2} alt="Kebun Jitu" className="w-12 aspect-square object-contain mb-5" loading='lazy' />
                        <h2 className="text-xl font-bold">Website</h2>
                        <p>www.kebunjitu.com</p>
                    </Link>
                    <Link
                        to="https://wa.me/6281222909869"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center justify-center cursor-pointer">
                        <img src={Icon3} alt="Kebun Jitu" className="w-12 aspect-square object-contain mb-5" loading='lazy' />
                        <h2 className="text-xl font-bold">Contact</h2>
                        <p>+62 81222909869</p>
                    </Link>
                </div>
            </div>
            <img src={Bg} alt="Kebun Jitu" className='absolute bottom-0 z-0' loading='lazy' />
        </div>
    )
}

export default Section10